export const environment = {
  env: "prod",
  production: true,
  clientId: "63e2b95a46fe236930a1683e",
  productMenuLoggedURL: "https://serasaexperian.com.br/meus-produtos",
  productMenuLoggedPMEURL:
    "https://empresas.serasaexperian.com.br/meus-produtos",
  productMenuMainURL: "https://serasaexperian.com.br/meus-produtos/login",
  productMenuMainPMEURL:
    "https://empresas.serasaexperian.com.br/meus-produtos/login",
  submenu: [
    {
      text: "Lista de usuários",
      icon: "supervisor_account",
      url: "/dashboard",
      dataTestId: "listagem",
    },
    {
      text: "Revisão de acessos",
      icon: "manage_accounts",
      url: "/revision",
      dataTestId: "revisao",
    },
    {
      text: "Histórico de ações",
      icon: "history",
      url: "/historico-acoes",
      dataTestId: "usuarios-excluidos",
    },    
    {
      text: "Autoatendimento",
      icon: "touch_app_rounded",
      url: "https://autoatendimento.serasaexperian.com.br",
      dataTestId: "auto-atendimento",
      clientId: "5b76db8946e0fb000e488a86"
    },
    {
      text: "Central de ajuda",
      icon: "help",
      url: "https://ajuda.serasaexperian.com.br/hc/pt-br",
      dataTestId: "central-de-ajuda",
    },
  ],
  logonPortalBaseUrl:
    "https://api.serasaexperian.com.br/digital/logon-portal/v1",
  accessesAdministration: {
    URL: "https://sitenet05.serasa.com.br/AutoAtendimento/Default/menuAcessos.aspx",
    clientId: "5b76db8946e0fb000e488a86"
  },
  DATADOG_APPLICATION_ID: "ca4df236-9d49-4273-b074-4e8a077cc305",
  DATADOG_CLIENT_TOKEN: "pub24cab6f58a4dad5dae6ae8724d387be0",
  DATADOG_SERVICE_NAME: "experian-logon-portal-prod",
  DATADOG_CONTEXT_TEAM: 'brazil_digital_paas',
  DATADOG_CONTEXT_COSTSTRING: '1800.br.124.404006',
  DATADOG_CONTEXT_BUSINESSSERVICE: 'authme'
};
